import { z } from 'zod';

// Схема для maintenance конфигурации
export const maintenanceConfigSchema = z.object({
  enabled: z.boolean(),
  message: z.string().nullable(),
});

// Feature flags — gamification defaults false until rollout sign-off (story 87-2).
export const featuresConfigSchema = z
  .object({
    gamification: z.boolean().optional().default(false),
  })
  .catchall(z.boolean());

// Схема для общей конфигурации приложения
export const appConfigSchema = z.object({
  maintenance: maintenanceConfigSchema,
  features: featuresConfigSchema,
});

// Типы для TypeScript
export type MaintenanceConfig = z.infer<typeof maintenanceConfigSchema>;
export type FeaturesConfig = z.infer<typeof featuresConfigSchema>;
export type AppConfig = z.infer<typeof appConfigSchema>;
